import { createGlobalStyle } from 'styled-components';
import 'animate.css/animate.min.css';
import 'react-toastify/dist/ReactToastify.css';
import colors from './colors';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  *:focus {
    outline: 0;
  }
  html, body {
    background: ${colors.secundary};
  }
  html {
    font-size: 62.5%;
  }
  @media (max-width: 1080px) {
    html {
    font-size: 58%;
    }
  }
  @media (max-width: 720px) {
    html {
      font-size: 54%;
    }
  }
  @media (max-width: 360px) {
    html {
      font-size: 52%;
    }
  }
   #root {
  }
  body {
    -webkit-font-smoothing: antialiased !important;
  }
  body, input, button {
    color: ${colors.primary};
    font-size:  1.4rem;
    font-family: 'Muli', sans-serif;

  }
  a {
    text-decoration: none;
  }
  ul {
    list-style: none;
  }
  button{
    cursor: pointer;
  }
  pre{
    font-family: inherit;
  }
`;
